import { AppShellSkeleton } from "../components/Skeleton.jsx";
import "./states.css";

/**
 * The one loading state that happens BEFORE there is an AppShell to put a page
 * skeleton inside: runtime config is still being fetched, so nothing about the
 * session is known yet.
 *
 * It still gets a skeleton rather than the spinner card it used to have,
 * because the shape at this moment is not unknown - it is always the shell
 * (rail, topbar, content). Drawing that means the first paint is already the
 * app taking shape instead of a small card alone on an empty page, and nothing
 * moves when the real shell replaces it.
 */
export default function ConfigLoadingState() {
  return <AppShellSkeleton label="กำลังเตรียมระบบ Workmate X - กำลังโหลดการตั้งค่าระบบ กรุณารอสักครู่" />;
}
